import * as React from "react";
import { forwardRef } from "react";
const SvgDropdown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10.287, height: 5.76, viewBox: "0 0 10.287 5.76", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 .631.631 0l4.513 4.512L9.656 0l.631.631-4.828 4.828-.315.3-.315-.3Z", className: "scd9be85e7bfdeb15367eafe7f85ad9af__a" }));
const ForwardRef = forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
